// Testimonials for the landing page.
// ⚠️ EDIT ME — replace these placeholders with real quotes from your happy clients.
// Ask satisfied customers for a 1-2 sentence quote + first name + last initial + city.
// (You can also add a photo path in `photo`; leave it out for text-only quotes.)
export const TESTIMONIALS = [
  {
    quote:
      "Switched from a big-box broker last spring. Saved $780 on renewal and they actually pick up the phone. First time in 10 years I feel like my broker knows my name.",
    name: "Kiran B.",
    location: "Brampton · Auto + Home",
  },
  {
    quote:
      "Was quoted $6,400 by my old company after one at-fault. AlwaysInsured rewrote me for $3,850 with better coverage. Made the switch in one afternoon.",
    name: "Rohit S.",
    location: "Mississauga · Auto",
  },
  {
    quote:
      "I run a small landscaping business — every other broker made commercial insurance feel impossible. These guys walked me through it in 20 minutes flat. Bound the same day.",
    name: "Manpreet K.",
    location: "Etobicoke · Commercial",
  },
  {
    quote:
      "Two-bedroom condo. New immigrant, no Canadian credit history. Every broker turned me away. AlwaysInsured found me tenant insurance in under an hour.",
    name: "Priya P.",
    location: "North York · Tenant",
  },
];
